export const inspectTable = [
  {
    key: 't1-001',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제4조 제3호',
      '유해·위험요인 확인·개선 절차마련(반기1회 점검)',
      '위험성평가 실시 및 위험성 감소대책 시행 (연1회)',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-002',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제4조 제8호',
      '중대산업재해 및 위험대비 매뉴얼',
      '급박한 위험(산업재해 발생) 대비 매뉴얼 상황별) 마련 및 조치',
      '전 부서(동)',
    ],
    isChecked: ``,
  },

  {
    key: 't1-003',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '부서(동)별 산재예방계획 수립',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-004',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '안전·보건 관리규정 게시',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-005',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '물질안전보건자료\n- 화학물질 보유 현황 목록화',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-006',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '물질안전보건자료\n- 물질안전보건자료 게시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-007',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '물질안전보건자료\n- 물질안전보건자료 교육',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-008',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '건강진단 \n' +
      '- 일반건강진단 실시',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-009',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '건강진단 \n' +
      '- 특수건강진단 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-010',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '보호구 \n' +
      '- 보호구 지급 및 착용 점검',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-011',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '보호구 \n' +
      '- 보호구 관리 대장 작성 여부',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-012',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업환경측정 \n' +
      '- 작업환경측정 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-013',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업환경측정 \n' +
      '- 측정결과 종사자에게 공지',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-014',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업환경측정 \n' +
      '- 작업환경 개선조치',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-015',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '근골격계 부담작업\n' +
      '- 근골격계유해요인조사 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-016',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '근골격계 부담작업\n' +
      '- 근골격계 부담작업 유해 요인 조사 결과 개선조치',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-017',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '밀폐공간\n' +
      '- 밀폐공간 작업 프로그램 수립',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-018',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '밀폐공간\n' +
      '- 밀폐공간 작업 프로그램 실시',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-019',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '유해·위험요인개선 등 안전보건 예산 \n' +
      '편성 및 집행',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-020',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '작업계획서 작성 및 작업지휘자 지정\n' +
      '(차량계 하역운반기계, 중량물 취급작업 등)',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-021',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '유해위험기계·기구 관리 안전검사 실시\n' +
      '<span style="color: #4839EB;\n">해당 있는 부서는 (대상기계기구 보유현황 및 점검일지, 안전검사필증(사진), 검사주기 등 </span>',
      '해당 부서',
    ],
    isChecked: ``,
  },
  {
    key: 't1-022',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '안전보건 표지설치',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-023',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제5조',
      '안전보건 관계법령상 의무이행 조치 \n' +
      '(반기1회 점검)',
      '법령요지 등 게시',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-024',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 채용시 교육',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-025',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 정기교육(분기6시간)',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-026',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 작업내용 변경시 교육',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
  {
    key: 't1-027',
    content: [
      '안전보건 관계법령상 의무이행',
      '중처법 시행령 제6조',
      '안전보건교육 실시 및 이수여부 확인\n' +
      '(반기 1회 점검)',
      '현업종사자\n' +
      '- 특별안전보건교육',
      '전 부서(동)',
    ],
    isChecked: ``,
  },
];

export const inspectTable2 = [
  {
    key: 't2-001',
    title: "1. 유해·위험요인 확인·개선 절차 마련",
    content: "1) 위험성평가 실시 및 위험성 감소대책 시행(연 1회)",
    isChecked: ``,
  },
  {
    key: 't2-002',
    title: "2. 중대산업재해 및 위험대비 매뉴얼",
    content: "1) 급박한 위험(산업재해 발생) 대비 매뉴얼(상황별) 마련 및 조치(반기 1회)",
    isChecked: ``,
  },
  {
    key: 't2-003',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "1) 부서(동)별 산재예방계획 수립",
    isChecked: ``,
  },
  {
    key: 't2-004',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "2) 안전·보건 관리규정 개시",
    isChecked: ``,
  },
  {
    key: 't2-005',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "3) 유해·위험요인개선 등 안전보건예산 편성 및 집행",
    isChecked: ``,
  },
  {
    key: 't2-006',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "4) 작업계획서 작성 및 작업지휘자 지정(차랑계 하역운반기계, 중량물취급작업 등)",
    isChecked: ``,
  },
  {
    key: 't2-007',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "5) 유해위험기계·기구 관리 안전검사 실시",
    isChecked: ``,
  },
  {
    key: 't2-008',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "6) 안전보건 표지 설치",
    isChecked: ``,
  },
  {
    key: 't2-009',
    title: "3. 안전보건 관계법령 상 의무이행 조치",
    content: "7) 법령요지 등 게시",
    isChecked: ``,
  },
  {
    key: 't2-010',
    title: "3-1. 물질안전보건자료",
    content: "1) 화학물질 보유 현황 목록화",
    isChecked: ``,
  },
  {
    key: 't2-011',
    title: "3-1. 물질안전보건자료",
    content: "2) 물질안전보건자료 게시",
    isChecked: ``,
  },
  {
    key: 't2-012',
    title: "3-1. 물질안전보건자료",
    content: "3) 물질안전보건자료 교육 실시",
    isChecked: ``,
  },
  {
    key: 't2-013',
    title: "3-2. 건강진단",
    content: "1) 일반건강진단 실시",
    isChecked: ``,
  },
  {
    key: 't2-014',
    title: "3-2. 건강진단",
    content: "2) 특수건강진단 실시",
    isChecked: ``,
  },
  {
    key: 't2-015',
    title: "3-3. 보호구",
    content: "1) 보호구 지급 및 착용 점검",
    isChecked: ``,
  },
  {
    key: 't2-016',
    title: "3-3. 보호구",
    content: "2) 보호구 관리대장 작성 여부",
    isChecked: ``,
  },
  {
    key: 't2-017',
    title: "3-4. 작업환경 측정",
    content: "1) 작업환경 측정 실시",
    isChecked: ``,
  },
  {
    key: 't2-018',
    title: "3-4. 작업환경 측정",
    content: "2) 측정결과 종사자에게 공지",
    isChecked: ``,
  },
  {
    key: 't2-019',
    title: "3-4. 작업환경 측정",
    content: "3) 작업환경 개선 조치",
    isChecked: ``,
  },
  {
    key: 't2-020',
    title: "3-5. 근골격계 부담작업",
    content: "1) 근골격계 유해요인 조사 실시",
    isChecked: ``,
  },
  {
    key: 't2-021',
    title: "3-5. 근골격계 부담작업",
    content: "2) 근골격계 부담작업 유해요인 조사결과 개선조치",
    isChecked: ``,
  },
  {
    key: 't2-022',
    title: "3-6. 밀폐공간",
    content: "1) 밀폐공간 작업 프로그램 수립",
    isChecked: ``,
  },
  {
    key: 't2-023',
    title: "3-6. 밀폐공간",
    content: "2) 밀폐공간 작업 프로그램 실시",
    isChecked: ``,
  },
  {
    key: 't2-024',
    title: "4. 안전보건총괄부서 등의 지도·조언에 대한 협조",
    content: "1) 안전관리자, 보건관리자, 안전보건관리담당자, 산업보건의의 지도·조언에 대한 협조",
    isChecked: ``,
  },
  {
    key: 't2-025',
    title: "5. 안전보건교육 실시 및 이수여부 확인",
    content: "1) 채용시 교육",
    isChecked: ``,
  },
  {
    key: 't2-026',
    title: "5. 안전보건교육 실시 및 이수여부 확인",
    content: "2) 정기교육(반기 12시간)",
    isChecked: ``,
  },
  {
    key: 't2-027',
    title: "5. 안전보건교육 실시 및 이수여부 확인",
    content: "3) 작업내용 변경 시 교육",
    isChecked: ``,
  },
  {
    key: 't2-028',
    title: "5. 안전보건교육 실시 및 이수여부 확인",
    content: "4) 특별안전보건교육",
    isChecked: ``,
  },
  {
    key: 't2-029',
    title: "6. 작업장 정리정돈 및 통로 확보 여부 확인",
    content: "1) 작업장 정리·정돈 확인",
    isChecked: ``,
  },
  {
    key: 't2-030',
    title: "6. 작업장 정리정돈 및 통로 확보 여부 확인",
    content: "2) 비상통로 확보여부",
    isChecked: ``,
  },
];

